module.exports = __webpack_public_path__ + "static/media/7.f857feb9.jpg";